// // src/pages/Dashboard/TransactionTable.js
// import React, { useMemo, useState, useEffect, useCallback } from "react"
// import {
//   Card,
//   CardBody,
//   CardTitle,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
//   UncontrolledDropdown,
//   Alert,
//   Button,
// } from "reactstrap"
// import TableContainer from "../../components/Common/TableContainer"
// import { getCombinedTransactionReport } from "../../helpers/api_helper"

// const TransactionTable = ({ filters }) => {
//   const [tableData, setTableData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(5)

//   const fetchData = useCallback(
//     async (newPageIndex = 0, newPageSize = pageSize) => {
//       setLoading(true)
//       setError(null)
//       const offset = newPageIndex * newPageSize

//       try {
//         const payload = {
//           limit: newPageSize,
//           offset,
//           startDate: filters?.startDate || null,
//           endDate: filters?.endDate || null,
//           mobileNumber:
//             Array.isArray(filters?.mobileNumbers) &&
//             filters.mobileNumbers.length > 0
//               ? filters.mobileNumbers
//               : null,
//         }

//         const res = await getCombinedTransactionReport(payload)

//         if (!res?.success || !res?.data) {
//           throw new Error(res?.error || "Invalid response from server")
//         }

//         setTotalRecords(res.totalRecords || 0)

//         const rows = []

//         Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//           Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//             const openingClosing = categories.opening_closing || {}

//             const withdrawTotal = categories.withdraw?.total?.amount || 0
//             const addedTotal = categories.added_money?.total?.amount || 0

//             const debitBreakdown = [
//               {
//                 name: "bajaj_599_debit",
//                 value: categories.bajaj_599_debit?.total?.amount || 0,
//               },
//               {
//                 name: "bajaj_699_debit",
//                 value: categories.bajaj_699_debit?.total?.amount || 0,
//               },
//               {
//                 name: "bajaj_other_debit",
//                 value: categories.bajaj_other_debit?.total?.amount || 0,
//               },
//               {
//                 name: "other_debit",
//                 value: categories.other_debit?.total?.amount || 0,
//               },
//             ]

//             const creditBreakdown = [
//               {
//                 name: "bajaj_credit",
//                 value: categories.bajaj_credit?.total?.amount || 0,
//               },
//               {
//                 name: "other_credit",
//                 value: categories.other_credit?.total?.amount || 0,
//               },
//               {
//                 name: "bajaj_refund",
//                 value: categories.bajaj_refund?.total?.amount || 0,
//               },
//               {
//                 name: "other_refund",
//                 value: categories.other_refund?.total?.amount || 0,
//               },
//             ]

//             rows.push({
//               date: date?.trim() || "",
//               mobile: mobile?.trim() || "",
//               opening: openingClosing.opening || 0,
//               closing: openingClosing.closing || 0,
//               opening_time: openingClosing.opening_time || "",
//               closing_time: openingClosing.closing_time || "",
//               withdraw: withdrawTotal,
//               added: addedTotal,
//               debitBreakdown,
//               creditBreakdown,
//             })
//           })
//         })

//         rows.sort((a, b) => new Date(b.date) - new Date(a.date))

//         setTableData(rows)
//         setPageIndex(newPageIndex)
//         setPageSize(newPageSize)
//       } catch (err) {
//         console.error("TransactionTable fetch error:", err)
//         setError(
//           err.message || "Failed to load transaction data. Please try again."
//         )
//         setTableData([])
//         setTotalRecords(0)
//       } finally {
//         setLoading(false)
//       }
//     },
//     [filters, pageSize]
//   )

//   useEffect(() => {
//     fetchData(0, pageSize)
//   }, [fetchData])

//   const formatCurrency = useCallback(val => {
//     return `₹${Number(val || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })}`
//   }, [])

//   const columns = useMemo(
//     () => [
//       {
//         header: "Transactions",
//         columns: [
//           {
//             header: "Date",
//             accessorKey: "date",
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false, // Extra disable
//           },
//           {
//             header: "Mobile",
//             accessorKey: "mobile",
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Opening",
//             accessorKey: "opening",
//             cell: ({ getValue }) => formatCurrency(getValue()),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Closing",
//             accessorKey: "closing",
//             cell: ({ getValue }) => formatCurrency(getValue()),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Withdraw",
//             accessorKey: "withdraw",
//             cell: ({ getValue }) => formatCurrency(getValue()),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Added",
//             accessorKey: "added",
//             cell: ({ getValue }) => formatCurrency(getValue()),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//         ],
//       },
//       {
//         header: "Total Debit",
//         columns: [
//           {
//             header: "Bajaj 599",
//             id: "bajaj599",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.debitBreakdown?.find(
//                   b => b.name === "bajaj_599_debit"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Bajaj 699",
//             id: "bajaj699",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.debitBreakdown?.find(
//                   b => b.name === "bajaj_699_debit"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Bajaj Other",
//             id: "bajajOther",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.debitBreakdown?.find(
//                   b => b.name === "bajaj_other_debit"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Other Debit",
//             id: "otherDebit",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.debitBreakdown?.find(b => b.name === "other_debit")
//                   ?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//         ],
//       },
//       {
//         header: "Total Credit",
//         columns: [
//           {
//             header: "Bajaj Credit",
//             id: "bajajCredit",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.creditBreakdown?.find(
//                   b => b.name === "bajaj_credit"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Other Credit",
//             id: "otherCredit",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.creditBreakdown?.find(
//                   b => b.name === "other_credit"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Bajaj Refund",
//             id: "bajajRefund",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.creditBreakdown?.find(
//                   b => b.name === "bajaj_refund"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//           {
//             header: "Other Refund",
//             id: "otherRefund",
//             cell: ({ row }) =>
//               formatCurrency(
//                 row.original.creditBreakdown?.find(
//                   b => b.name === "other_refund"
//                 )?.value || 0
//               ),
//             enableColumnFilter: false,
//             enableSorting: true,
//             filterable: false,
//           },
//         ],
//       },
//     ],
//     [formatCurrency]
//   )

//   // Export logic (same as before, but with useCallback for better perf)
//   const flattenDataForExport = useCallback(() => {
//     return tableData.map(item => ({
//       "Date Time": item.opening_time || item.closing_time || item.date || "",
//       Mobile: item.mobile || "",
//       Opening: item.opening || 0,
//       Closing: item.closing || 0,
//       Withdraw: item.withdraw || 0,
//       Added: item.added || 0,
//       "Bajaj 599":
//         item.debitBreakdown?.find(b => b.name === "bajaj_599_debit")?.value ||
//         0,
//       "Bajaj 699":
//         item.debitBreakdown?.find(b => b.name === "bajaj_699_debit")?.value ||
//         0,
//       "Bajaj Other Debit":
//         item.debitBreakdown?.find(b => b.name === "bajaj_other_debit")?.value ||
//         0,
//       "Other Debit":
//         item.debitBreakdown?.find(b => b.name === "other_debit")?.value || 0,
//       "Bajaj Credit":
//         item.creditBreakdown?.find(b => b.name === "bajaj_credit")?.value || 0,
//       "Other Credit":
//         item.creditBreakdown?.find(b => b.name === "other_credit")?.value || 0,
//       "Bajaj Refund":
//         item.creditBreakdown?.find(b => b.name === "bajaj_refund")?.value || 0,
//       "Other Refund":
//         item.creditBreakdown?.find(b => b.name === "other_refund")?.value || 0,
//     }))
//   }, [tableData])

//   const exportToCSV = useCallback(() => {
//     const exportData = flattenDataForExport()
//     if (exportData.length === 0) {
//       alert("No transactions available to export.")
//       return
//     }

//     const headers = Object.keys(exportData[0])
//     const csvRows = [headers.join(",")]

//     exportData.forEach(row => {
//       const values = headers.map(header => {
//         let val = row[header] ?? ""
//         if (
//           typeof val === "string" &&
//           (val.includes(",") || val.includes('"') || val.includes("\n"))
//         ) {
//           val = `"${val.replace(/"/g, '""')}"`
//         }
//         return val
//       })
//       csvRows.push(values.join(","))
//     })

//     const csvContent = csvRows.join("\n")
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.download = `transactions_report_${
//       new Date().toISOString().split("T")[0]
//     }.csv`
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }, [flattenDataForExport])

//   return (
//     <Card className="shadow border-0 mb-0">
//       <div className="card-header border-0 py-3 px-4">
//         <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
//           <CardTitle tag="h5" className="mb-0 fw-semibold">
//             Transaction Details (Combined Report)
//           </CardTitle>

//           <UncontrolledDropdown direction="start">
//             <DropdownToggle
//               tag="button"
//               className="btn btn-soft-secondary btn-sm"
//             >
//               Export <i className="mdi mdi-chevron-down ms-1"></i>
//             </DropdownToggle>
//             <DropdownMenu className="dropdown-menu-end">
//               <DropdownItem onClick={exportToCSV}>Download CSV</DropdownItem>
//             </DropdownMenu>
//           </UncontrolledDropdown>
//         </div>
//       </div>

//       <CardBody className="p-4">
//         {loading ? (
//           <div className="text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading transactions...</span>
//             </div>
//             <p className="mt-3 text-muted">Fetching data, please wait...</p>
//           </div>
//         ) : error ? (
//           <Alert
//             color="danger"
//             className="d-flex align-items-center justify-content-between"
//           >
//             <div className="d-flex align-items-center">
//               <i className="ri-error-warning-line fs-4 me-3"></i>
//               <div>
//                 <h5 className="alert-heading mb-1">
//                   Error Loading Transactions
//                 </h5>
//                 <p className="mb-0">{error}</p>
//               </div>
//             </div>
//             <Button
//               color="danger"
//               outline
//               size="sm"
//               onClick={() => fetchData(pageIndex, pageSize)}
//             >
//               Retry
//             </Button>
//           </Alert>
//         ) : tableData.length === 0 ? (
//           <div className="text-center py-5 text-muted">
//             <i className="ri-file-list-3-line fs-1 mb-3 d-block"></i>
//             <h5>No transactions found</h5>
//             <p>Try changing filters or check back later.</p>
//           </div>
//         ) : (
//           <TableContainer
//             columns={columns}
//             data={tableData}
//             isGlobalFilter={false}
//             isAddOptions={false} // Extra: agar global add button ho to disable
//             isPagination={true}
//             manualPagination={true}
//             isCustomPageSize={true}
//             pageCount={
//               totalRecords > 0 ? Math.ceil(totalRecords / pageSize) : 0
//             }
//             pageIndex={pageIndex}
//             pageSize={pageSize}
//             totalRecords={totalRecords}
//             onPaginationChange={(newPageIndex, newPageSize) => {
//               setPageSize(newPageSize)
//               fetchData(newPageIndex, newPageSize)
//             }}
//             pagination="pagination"
//             paginationWrapper="dataTables_paginate paging_simple_numbers"
//             tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
//             // Yeh important props agar component support kare
//             enableColumnFilters={false} // TanStack Table ke liye common prop
//             disableFilters={true} // Agar custom prop ho
//           />
//         )}
//       </CardBody>
//     </Card>
//   )
// }

// export default TransactionTable

// src/pages/Dashboard/TransactionTable.js
import React, { useMemo, useState, useEffect, useCallback } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Alert,
  Button,
} from "reactstrap"
import TableContainer from "../../components/Common/TableContainer"
import { getCombinedTransactionReport } from "../../helpers/api_helper"

const TransactionTable = ({ filters, tabKey, sharedCache }) => {
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(5)

  const getCacheKey = (pIndex, pSize) => `${tabKey}-${pIndex}-${pSize}`

  const fetchData = useCallback(
    async (newPageIndex = 0, newPageSize = pageSize) => {
      setLoading(true)
      setError(null)

      const key = getCacheKey(newPageIndex, newPageSize)

      // Cache hit → rows + totalRecords dono wapas set
      if (sharedCache.current.has(key)) {
        const cached = sharedCache.current.get(key)
        setTableData(cached.rows)
        setTotalRecords(cached.totalRecords)
        setPageIndex(newPageIndex)
        setPageSize(newPageSize)
        setLoading(false)
        return
      }

      const offset = newPageIndex * newPageSize

      try {
        const payload = {
          limit: newPageSize,
          offset,
          startDate: filters?.startDate || null,
          endDate: filters?.endDate || null,
          mobileNumber:
            Array.isArray(filters?.mobileNumbers) &&
            filters.mobileNumbers.length > 0
              ? filters.mobileNumbers
              : null,
        }

        const res = await getCombinedTransactionReport(payload)

        if (!res?.success || !res?.data) {
          throw new Error(res?.error || "Invalid response from server")
        }

        const currentTotal = res.totalRecords || 0
        setTotalRecords(currentTotal)

        const rows = []

        Object.entries(res.data || {}).forEach(([date, mobiles]) => {
          Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
            const openingClosing = categories.opening_closing || {}

            const withdrawTotal = categories.withdraw?.total?.amount || 0
            const addedTotal = categories.added_money?.total?.amount || 0

            const debitBreakdown = [
              {
                name: "bajaj_599_debit",
                value: categories.bajaj_599_debit?.total?.amount || 0,
              },
              {
                name: "bajaj_699_debit",
                value: categories.bajaj_699_debit?.total?.amount || 0,
              },
              {
                name: "bajaj_other_debit",
                value: categories.bajaj_other_debit?.total?.amount || 0,
              },
              {
                name: "other_debit",
                value: categories.other_debit?.total?.amount || 0,
              },
            ]

            const creditBreakdown = [
              {
                name: "bajaj_credit",
                value: categories.bajaj_credit?.total?.amount || 0,
              },
              {
                name: "other_credit",
                value: categories.other_credit?.total?.amount || 0,
              },
              {
                name: "bajaj_refund",
                value: categories.bajaj_refund?.total?.amount || 0,
              },
              {
                name: "other_refund",
                value: categories.other_refund?.total?.amount || 0,
              },
            ]

            rows.push({
              date: date?.trim() || "",
              mobile: mobile?.trim() || "",
              opening: openingClosing.opening || 0,
              closing: openingClosing.closing || 0,
              opening_time: openingClosing.opening_time || "",
              closing_time: openingClosing.closing_time || "",
              withdraw: withdrawTotal,
              added: addedTotal,
              debitBreakdown,
              creditBreakdown,
            })
          })
        })

        rows.sort((a, b) => new Date(b.date) - new Date(a.date))

        // Cache mein rows + totalRecords dono save kar rahe hain
        sharedCache.current.set(key, {
          rows,
          totalRecords: currentTotal,
          timestamp: Date.now(),
        })

        setTableData(rows)
        setPageIndex(newPageIndex)
        setPageSize(newPageSize)
      } catch (err) {
        console.error("TransactionTable fetch error:", err)
        setError(
          err.message || "Failed to load transaction data. Please try again."
        )
        setTableData([])
        setTotalRecords(0)
        sharedCache.current.delete(key)
      } finally {
        setLoading(false)
      }
    },
    [filters, pageSize, sharedCache, tabKey]
  )

  useEffect(() => {
    fetchData(0, pageSize)
  }, [fetchData])

  const formatCurrency = useCallback(val => {
    return `₹${Number(val || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  }, [])

  const columns = useMemo(
    () => [
      {
        header: "Transactions",
        columns: [
          {
            header: "Date",
            accessorKey: "date",
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Mobile",
            accessorKey: "mobile",
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Opening",
            accessorKey: "opening",
            cell: ({ getValue }) => formatCurrency(getValue()),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Closing",
            accessorKey: "closing",
            cell: ({ getValue }) => formatCurrency(getValue()),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Withdraw",
            accessorKey: "withdraw",
            cell: ({ getValue }) => formatCurrency(getValue()),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Added",
            accessorKey: "added",
            cell: ({ getValue }) => formatCurrency(getValue()),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
        ],
      },
      {
        header: "Total Debit",
        columns: [
          {
            header: "Bajaj 599",
            id: "bajaj599",
            cell: ({ row }) =>
              formatCurrency(
                row.original.debitBreakdown?.find(
                  b => b.name === "bajaj_599_debit"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Bajaj 699",
            id: "bajaj699",
            cell: ({ row }) =>
              formatCurrency(
                row.original.debitBreakdown?.find(
                  b => b.name === "bajaj_699_debit"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Bajaj Other",
            id: "bajajOther",
            cell: ({ row }) =>
              formatCurrency(
                row.original.debitBreakdown?.find(
                  b => b.name === "bajaj_other_debit"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Other Debit",
            id: "otherDebit",
            cell: ({ row }) =>
              formatCurrency(
                row.original.debitBreakdown?.find(b => b.name === "other_debit")
                  ?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
        ],
      },
      {
        header: "Total Credit",
        columns: [
          {
            header: "Bajaj Credit",
            id: "bajajCredit",
            cell: ({ row }) =>
              formatCurrency(
                row.original.creditBreakdown?.find(
                  b => b.name === "bajaj_credit"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Other Credit",
            id: "otherCredit",
            cell: ({ row }) =>
              formatCurrency(
                row.original.creditBreakdown?.find(
                  b => b.name === "other_credit"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Bajaj Refund",
            id: "bajajRefund",
            cell: ({ row }) =>
              formatCurrency(
                row.original.creditBreakdown?.find(
                  b => b.name === "bajaj_refund"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
          {
            header: "Other Refund",
            id: "otherRefund",
            cell: ({ row }) =>
              formatCurrency(
                row.original.creditBreakdown?.find(
                  b => b.name === "other_refund"
                )?.value || 0
              ),
            enableColumnFilter: false,
            enableSorting: true,
            filterable: false,
          },
        ],
      },
    ],
    [formatCurrency]
  )

  // Export logic (same as before, but with useCallback for better perf)
  const flattenDataForExport = useCallback(() => {
    return tableData.map(item => ({
      "Date Time": item.opening_time || item.closing_time || item.date || "",
      Mobile: item.mobile || "",
      Opening: item.opening || 0,
      Closing: item.closing || 0,
      Withdraw: item.withdraw || 0,
      Added: item.added || 0,
      "Bajaj 599":
        item.debitBreakdown?.find(b => b.name === "bajaj_599_debit")?.value ||
        0,
      "Bajaj 699":
        item.debitBreakdown?.find(b => b.name === "bajaj_699_debit")?.value ||
        0,
      "Bajaj Other Debit":
        item.debitBreakdown?.find(b => b.name === "bajaj_other_debit")?.value ||
        0,
      "Other Debit":
        item.debitBreakdown?.find(b => b.name === "other_debit")?.value || 0,
      "Bajaj Credit":
        item.creditBreakdown?.find(b => b.name === "bajaj_credit")?.value || 0,
      "Other Credit":
        item.creditBreakdown?.find(b => b.name === "other_credit")?.value || 0,
      "Bajaj Refund":
        item.creditBreakdown?.find(b => b.name === "bajaj_refund")?.value || 0,
      "Other Refund":
        item.creditBreakdown?.find(b => b.name === "other_refund")?.value || 0,
    }))
  }, [tableData])

  const exportToCSV = useCallback(() => {
    const exportData = flattenDataForExport()
    if (exportData.length === 0) {
      alert("No transactions available to export.")
      return
    }

    const headers = Object.keys(exportData[0])
    const csvRows = [headers.join(",")]

    exportData.forEach(row => {
      const values = headers.map(header => {
        let val = row[header] ?? ""
        if (
          typeof val === "string" &&
          (val.includes(",") || val.includes('"') || val.includes("\n"))
        ) {
          val = `"${val.replace(/"/g, '""')}"`
        }
        return val
      })
      csvRows.push(values.join(","))
    })

    const csvContent = csvRows.join("\n")
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = `transactions_report_${
      new Date().toISOString().split("T")[0]
    }.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }, [flattenDataForExport])

  return (
    <Card className="shadow border-0 mb-0">
      <div className="card-header border-0 py-3 px-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          <CardTitle tag="h5" className="mb-0 fw-semibold">
            Transaction Details (Combined Report)
          </CardTitle>

          <UncontrolledDropdown direction="start">
            <DropdownToggle
              tag="button"
              className="btn btn-soft-secondary btn-sm"
            >
              Export <i className="mdi mdi-chevron-down ms-1"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem onClick={exportToCSV}>Download CSV</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>

      <CardBody className="p-4">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading transactions...</span>
            </div>
            <p className="mt-3 text-muted">Fetching data, please wait...</p>
          </div>
        ) : error ? (
          <Alert
            color="danger"
            className="d-flex align-items-center justify-content-between"
          >
            <div className="d-flex align-items-center">
              <i className="ri-error-warning-line fs-4 me-3"></i>
              <div>
                <h5 className="alert-heading mb-1">
                  Error Loading Transactions
                </h5>
                <p className="mb-0">{error}</p>
              </div>
            </div>
            <Button
              color="danger"
              outline
              size="sm"
              onClick={() => fetchData(pageIndex, pageSize)}
            >
              Retry
            </Button>
          </Alert>
        ) : tableData.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <i className="ri-file-list-3-line fs-1 mb-3 d-block"></i>
            <h5>No transactions found</h5>
            <p>Try changing filters or check back later.</p>
          </div>
        ) : (
          <TableContainer
            columns={columns}
            data={tableData}
            isGlobalFilter={false}
            isAddOptions={false}
            isPagination={true}
            manualPagination={true}
            isCustomPageSize={true}
            pageCount={
              totalRecords > 0 ? Math.ceil(totalRecords / pageSize) : 0
            }
            pageIndex={pageIndex}
            pageSize={pageSize}
            totalRecords={totalRecords}
            onPaginationChange={(newPageIndex, newPageSize) => {
              setPageSize(newPageSize)
              fetchData(newPageIndex, newPageSize)
            }}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            enableColumnFilters={false}
            disableFilters={true}
          />
        )}
      </CardBody>
    </Card>
  )
}
export default TransactionTable
